/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Custombusinessbundesland2Inputs */

const de__field_custombusinessbundesland2 = /** @type {(inputs: _Field_Custombusinessbundesland2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstadresse-Bundesland`)
};

/**

* @param {_Field_Custombusinessbundesland2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_custombusinessbundesland2 = /** @type {((inputs?: _Field_Custombusinessbundesland2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Custombusinessbundesland2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_custombusinessbundesland2(inputs)
});
export { _field_custombusinessbundesland2 as "_field_customBusinessBundesland" }